export interface BarSpacerProps extends React.ComponentPropsWithoutRef<'i'> {
  orientation?: 'x' | 'y';
}

const BarSpacer: React.VFC<BarSpacerProps> = ({orientation = 'x', className = '', ...rest}) => {
  return <i className={`block ${orientation === 'x' ? 'border-l my-2' : 'border-t mx-2'} ${className}`} {...rest} />;
};

export default BarSpacer;
